import { combineReducers } from 'redux'

import isOpen from './isOpen'

export default combineReducers({
  isOpen,
})
